import REGEX from './regex.js';

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

export default validate;


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/validate.js
// module id = 155
// module chunks = 0